export type SplitCellRef = {
  columnId: string;
  productId: string;
  fieldSelector: string;
  /** Absolute period, including strip formulas that themselves contain `:`. */
  period: string;
};

/**
 * Cell refs are `columnId:productId:fieldSelector:period`. The period is
 * everything after the third `:`, so strip ids like `FEB26:MAR26` stay intact.
 */
export const splitCellRef = (ref: string): SplitCellRef | null => {
  const first = ref.indexOf(":");
  if (first === -1) return null;
  const second = ref.indexOf(":", first + 1);
  if (second === -1) return null;
  const third = ref.indexOf(":", second + 1);
  if (third === -1) return null;
  return {
    columnId: ref.slice(0, first),
    productId: ref.slice(first + 1, second),
    fieldSelector: ref.slice(second + 1, third),
    period: ref.slice(third + 1),
  };
};

export const periodFromCellRef = (ref: string): string | null => {
  const period = splitCellRef(ref)?.period;
  return period || null;
};
